import { render, staticRenderFns } from "./MealItemCombos.vue?vue&type=template&id=3a2ff74c&scoped=true"
import script from "./MealItemCombos.vue?vue&type=script&lang=js"
export * from "./MealItemCombos.vue?vue&type=script&lang=js"
import style0 from "./MealItemCombos.vue?vue&type=style&index=0&id=3a2ff74c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ff74c",
  null
  
)

export default component.exports